import { Box, BoxProps } from "@mui/material";
import { forwardRef } from "react";

export const VerticalBox = forwardRef(({ sx, ...other }: BoxProps, ref) => {
	return (
		<Box
			ref={ref}
			sx={{
				display: "flex",
				flexDirection: "column",
				...sx,
			}}
			{...other}
		/>
	);
});
